
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/3catinfo/eleccions-autonomiques-28m-2023/embed/[slugEmbed]",
      function () {
        return require("private-next-pages/3catinfo/eleccions-autonomiques-28m-2023/embed/[slugEmbed]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/3catinfo/eleccions-autonomiques-28m-2023/embed/[slugEmbed]"])
      });
    }
  